import { useMutation } from "react-query";
import authAPI from "../authAPI";

export const usePreviewFeideId = () => {
  return useMutation(
    ({ feideId, autoImportChildren, autoImportParents }) =>
      authAPI.previewFeideId(feideId, autoImportChildren, autoImportParents)
  );
};
